import { Resource } from "../../hooks/useGlobalResources";

export const generateResources = (resources: Resource[]) => {
    return resources.map((resource: Resource) => resource.name);
  };